import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OpenSquashService } from '../../shared/services/open-squash-service';
import { CreatePlayerComponent } from '../create-player-component/create-player-component';
import { Match, MatchExtended, MatchState } from '../../shared/model/match';
import { NgxQrcodeStylingComponent, Options, TemplateType } from 'ngx-qrcode-styling';
import { environment } from '../../../../environments/environment';
import { parseCourtNumber } from '../../shared/util/court.util';

@Component({
  selector: 'app-start-match-component',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgxQrcodeStylingComponent,
  ],
  templateUrl: './start-match-component.html',
  styleUrl: './start-match-component.scss'
})
export class StartMatchComponent implements OnInit {
  public data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<CreatePlayerComponent>);
  private fb = inject(FormBuilder);

  private openSquashService = inject(OpenSquashService);
  match!: MatchExtended;
  config: any; // Configuración del QR

  ngOnInit() {
    this.match = { ...this.data.match };  
    this.config = {
      width: 250,
      height: 250,
      margin: 20,
      data: environment.urlApp + 'referee/' + this.match.code,
      image: 'images/no-avatar.png',
      qrOptions: {
        errorCorrectionLevel: 'M'
      },
      backgroundOptions: { color: '#faf9fd' },
      template: 'bitcoin'
    };
  }

  form: FormGroup = this.fb.group({
    court: ['', Validators.required],
  });

  submit() {
    if (this.form.valid) {
      const match = { ...this.data.match };
      match.court = parseCourtNumber(this.form.value.court);
      match.state = MatchState.PROGRAMADO;
      match.playerIdWinner = null;

      this.openSquashService.updateMatch(match).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  exit() {
    this.dialogRef.close(null);
  }
}

